// Libs
import React from "react";

// DLS
import "@collectivehealth/dls-alerts";

// Styles
import toastListStyle from "@collectivehealth/dls-alerts/dist/toast-list.css";

// Components
import RenderIf from "components/RenderIf";

// Context
import ToasterContext from "contexts/Toaster";

// Constants
import { TOAST_ACTIONS } from "constants/toast";
export const DATA_HOOK = "Toaster";

export default class Toaster extends React.Component {
  static contextType = ToasterContext;

  constructor(props) {
    super(props);

    this.toastListRef = React.createRef();
  }

  componentDidMount() {
    this.toastListRef.current.addEventListener("dls-toast-hidden", this.onHideToast);
  }

  componentWillUnmount() {
    this.toastListRef.current.removeEventListener("dls-toast-hidden", this.onHideToast);
  }

  render() {
    return (
      <div slot="page-warn" data-hook={DATA_HOOK}>
        <div className={toastListStyle.toastList} ref={this.toastListRef}>
          {this.context.state.map(toastProps => this.renderToast(toastProps))}
        </div>
      </div>
    );
  }

  // EVENT HANDLERS

  /**
   * Handles the event dispatched when a toast is hidden
   * @param {event} event dls-toast-hidden event
   */
  onHideToast = event => {
    this.context.dispatch({
      type: TOAST_ACTIONS.REMOVE_TOAST,
      id: event.target.dataset.id
    });
  };

  // RENDERERS

  /**
   * Renders a toast node
   * @param {node} header Default text slot; header of the toast
   * @param {node} body Body slot; text for body of the toast
   * @param {string} status Status; "critical", "info" (default), "success", "warning"
   */
  renderToast({ header, body, status, ...props }) {
    const id = new Date().getTime();
    return (
      <dls-toast-alert key={id} data-id={id} status={status} shown="shown" {...props}>
        <span slot="toast-alert-text">{header}</span>
        <RenderIf test={!!body}>
          <span slot="toast-alert-body">{body}</span>
        </RenderIf>
      </dls-toast-alert>
    );
  }
}
